"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ReactElementUtils = require("../../../utils/ReactElementUtils");

var _FlexLayout = _interopRequireDefault(require("./FlexLayout"));

var _FlexItem = _interopRequireDefault(require("./FlexItem"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var styleKeys = ['fullPage', 'leftPanelVisible'];
/**
 * The main page layout used in Prism. This consists of the
 * header, left panel and body. The left panel can be optional.
 */

var MainPageLayout =
/*#__PURE__*/
function (_React$Component) {
  _inherits(MainPageLayout, _React$Component);

  function MainPageLayout() {
    _classCallCheck(this, MainPageLayout);

    return _possibleConstructorReturn(this, _getPrototypeOf(MainPageLayout).apply(this, arguments));
  }

  _createClass(MainPageLayout, [{
    key: "render",
    value: function render() {
      /* eslint-disable no-unused-vars */
      var _this$props = this.props,
          className = _this$props.className,
          fullPage = _this$props.fullPage,
          header = _this$props.header,
          leftPanel = _this$props.leftPanel,
          leftPanelVisible = _this$props.leftPanelVisible,
          body = _this$props.body,
          props = _objectWithoutProperties(_this$props, ["className", "fullPage", "header", "leftPanel", "leftPanelVisible", "body"]);
      /* eslint-enable */


      var styleProps = (0, _ReactElementUtils.getStyleProps)(styleKeys, this.props);
      var leftPanelNode;

      if (leftPanel) {
        leftPanelNode = _react.default.createElement(_FlexItem.default, {
          className: "left-panel"
        }, leftPanel);
      }

      return _react.default.createElement(_FlexLayout.default, _extends({
        className: (0, _classnames.default)(className, "".concat(_ThemeManager.default.getVar('classPrefix'), "-main-page-layout")),
        flexDirection: "column",
        itemSpacing: "0px"
      }, styleProps, props), _react.default.createElement(_FlexItem.default, {
        className: "header"
      }, header), _react.default.createElement(_FlexLayout.default, {
        className: "body-wrapper",
        itemSpacing: "0px",
        flexGrow: "1"
      }, leftPanelNode, _react.default.createElement(_FlexItem.default, {
        className: "body",
        flexGrow: "1"
      }, body)));
    }
  }]);

  return MainPageLayout;
}(_react.default.Component);

exports.default = MainPageLayout;
MainPageLayout.defaultProps = {
  leftPanelVisible: true
};
MainPageLayout.propTypes = {
  /**
   * Additional custom class name.
   */
  className: _propTypes.default.string,

  /**
   * Makes layout absolute position and encompasses all available space
   * allowed for layout.
   */
  fullPage: _propTypes.default.bool,

  /**
   * The content for the header.
   */
  header: _propTypes.default.node,
  // TODO: Mark isRequired after migration

  /**
   * The content for the left panel.
   */
  leftPanel: _propTypes.default.node,

  /**
   * Visibility of left panel.
   */
  leftPanelVisible: _propTypes.default.bool,

  /**
   * The content for the body.
   */
  body: _propTypes.default.node
};